const CLOUDINARY_UPLOAD_URL =
  "https://api.cloudinary.com/v1_1/djfalwqw8/image/upload";

export const uploadImage = async (dataUrl: string): Promise<string> => {
  const formData = new FormData();
  formData.append("file", dataUrl);
  formData.append("upload_preset", "unsigned_preset");

  const response = await fetch(CLOUDINARY_UPLOAD_URL, {
    method: "POST",
    body: formData,
  });

  if (response.status !== 200) {
    throw new Error(`Failed to upload image: ${response.status}`);
  }

  const responseJSON = JSON.parse(await response.text());
  return responseJSON["secure_url"];
};
